import { Component, OnInit, signal, Signal } from '@angular/core';

import { LoaderService } from './loader.service';

@Component({
  selector: 'carehub-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  loading: Signal<boolean> = signal(false);

  constructor(private _loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loading = this._loaderService.loading;
  }
}
